module.exports = __webpack_public_path__ + "static/media/student-summary-100p.6f56c533.png";